module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-d2c1311907c870a402e58bf7888e1d12.svg";